import createSlice from "admin/store/create-slice";
import initialState from "admin/store/initial-state-schema";
import { getApiUrl } from 'shared-kernel/helpers';

const name = 'useraddress';

const slice = createSlice({
    name,
    initialState,
    reducers: {
        requested: state => ({
            ...state,
            isFetching: true
        }),
        failed: state => ({
            ...state,
            isFetching: false,
            isFailed: true
        }),
        itemReceived: (state, payload) => ({
            ...state,
            isFetching: false,
            items: payload.data
        })
    }
});

const { requested, failed, itemReceived } = slice.actions;

export default slice.reducer;

export const getBy = userId => ({
    types: [requested.type, itemReceived.type, failed.type],
    url: getApiUrl(name, 'getBy'),
    payload: { userId }
});